<script lang="ts">
  import globalStore from '../../stores/global.svelte'
  import LaunchpadNavBottom from './LaunchpadNavBottom.svelte'

  let keyword = globalStore.currentAccount.first_keyword.keyword
  let shortCode = globalStore.currentAccount.short_code
  let groupToken = globalStore.currentAccount.all_group.token
</script>

<div class="LaunchpadGotNoContacts">

  <div class="flex-row align-bottom">
    <div class="cell-3 cell-left">
      <h2>Got No Contacts?</h2>
      <p>
        Here are some of the ways you can build a list from scratch:
      </p>

      <div class="flex-row">
        <div class="cell-0">
          <span class="bullet-number">1</span>
        </div>
        <div class="cell-1">
          <h3>Use a Keyword</h3>
          <p>
            Texting your keyword into the shortcode (phone number) {shortCode}
            is how contacts can subscribe to your list right from their phones.
          </p>
          <p>
            &bull; Text <strong>{keyword}</strong> to <strong>{shortCode}</strong>
          </p>

          <hr class="mb-0">
        </div>
      </div>
    </div>
    <div class="cell-1 cell-right">
      <p class="pt-1">
        Simple and anyone can join from their phone
      </p>
      <div class="white-circle">
        <div class="white-circle-content">
          TEXT
          <br>
          <strong>{keyword}</strong>
          <br>
          TO
          <br>
          <strong>{shortCode}</strong>
        </div>
      </div>
      <hr class="mb-0">
    </div>
  </div>


  <div class="flex-row align-bottom">
    <div class="cell-3 cell-left">
      <div class="flex-row">
        <div class="cell-0">
          <span class="bullet-number">2</span>
        </div>
        <div class="cell-1">
          <h3>Put up a call to action</h3>
          <p>
            The phrase "Text {keyword} to {shortCode}"
            can work in just about any format. For example:
          </p>
          <p>
            You can <strong>tell</strong> it to someone
            ("Hey, want to be on my list? Text...")
            <br>
            You can <strong>post</strong> it on a sign
            ("Want to be on my VIP list? Text...")
            <br>
            You can <strong>post</strong> it to social media
            ("Get my latest updates via text. Text...")
          </p>

          <hr class="mb-0">
        </div>
      </div>
    </div>

    <div class="cell-1 cell-right">
      <p class="m-b-3">
        Here is an example of how it will look on a webpage
      </p>
      <p class="m-b-3">
        <a href="/w/{groupToken}" class="btn btn-green btn-rounded" target="_blank">Web Sign Up</a>
      </p>

      <hr class="mb-0">
    </div>
  </div>


  <div class="flex-row align-bottom">
    <div class="cell-3 cell-left">
      <div class="flex-row">
        <div class="cell-0">
          <span class="bullet-number">3</span>
        </div>
        <div class="cell-1">
          <h3>Want to build an audience in a specific group?</h3>
          <p>
            With txtsignal, you can set up additional groups and each group
            can have its own unique keyword.
          </p>

          <hr class="mb-0 mt-5">
        </div>
      </div>
    </div>

    <div class="cell-1 cell-right">
      <p class="mb-2">
        Create another keyword
      </p>
      <p class="mb-2">
        <a href="/keywords" class="btn btn-green btn-rounded">Go to Keywords</a>
      </p>

      <hr class="mb-0">
    </div>
  </div>

  <div style="margin: 0 1.5em 1em;">
    <LaunchpadNavBottom class="pull-up"></LaunchpadNavBottom>
  </div>

</div>
